import script from "./ProductRecently.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRecently.vue?vue&type=script&setup=true&lang=js"

import "./ProductRecently.vue?vue&type=style&index=0&id=f9acaaf0&lang=scss&scoped=true"
import "./ProductRecently.vue?vue&type=style&index=1&id=f9acaaf0&lang=scss"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9acaaf0"]])

export default __exports__